module.exports = __webpack_public_path__ + "static/media/verified.9421a9cc.svg";